import { useState, useEffect } from 'react';
import {
  ensureValidUri,
  getPPUrl,
  getPPAuthToken,
} from '@r-and-a-shared-ui/utils';

import { AUTH_TOKEN_KEY } from '../constants/playerPortals';

export type QueryResponse = {
  items?: Array<any>;
  errorKey: string;
  httpStatusCode: number;
  successCode: string;
};

const useFetchAccreditationFormData = (
  accreditationFormAPI: any,
  championshipPlayerId: string,
  callbackUrl?: string | undefined,
) => {
  const [data, setData] = useState<QueryResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const mutation =
    accreditationFormAPI?.accreditation_form_contacts?.useMutation();
  const authTokenMutation =
    accreditationFormAPI?.[AUTH_TOKEN_KEY]?.useMutation();

  const defaultValues = mutation?.mutateAsync;

  const fetchData = async () => {
    setLoading(true);

    const bearerToken = await getPPAuthToken(authTokenMutation.mutateAsync);

    const fullCallbackUrl = ensureValidUri(callbackUrl, getPPUrl());

    try {
      const res = await defaultValues({
        callBackUrl: fullCallbackUrl,
        bearerToken,
        championshipPlayerId: championshipPlayerId,
      });

      setData(res);
    } catch (err: any) {
      console.error('Error fetching accreditation form data:', err);
    } finally {
      setLoading(false);
      setHasFetched(true);
    }
  };

  useEffect(() => {
    if (!callbackUrl || !championshipPlayerId) {
      setData(null);
      return;
    }

    fetchData();
  }, [callbackUrl, championshipPlayerId]);

  return { data, loading, hasFetched, refetch: fetchData };
};

export default useFetchAccreditationFormData;
